import { render, staticRenderFns } from "./OrganizationMenu.vue?vue&type=template&id=6f306c5b&"
import script from "./OrganizationMenu.vue?vue&type=script&lang=ts&"
export * from "./OrganizationMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports